<!--
	作者：masonchen
	时间：2017-04-07
	描述：报警计划中心子页面
-->
<template>
	<div class="col-sm-3 col-lg-2 alarm_list_single" v-bind:class="{'not_available_active': cellData.isEnable=='0' }">
			<div @click="addTab(cellData.alarmType,cellData.alarmTypeName,cellData.alarmPageName,cellData.isEnable)" class="alarm_list_icon02" v-bind:class="cellData.bgcolor"> 
				<em><img :src="imageData" width="30" height="30" alt=""/></em> 
				<span>{{cellData.title}}</span>
				<a>进入&gt;&gt;</a>
			</div>
			<div class="alarm_list_text">
				<p>
					<a @click.stop="addAlarmTab(cellData.alarmType)">已有{{cellData.count}}个计划</a>
				</p>
				<span style="height:75px;">{{cellData.message}}</span> 
				<div v-if = "cellData.isEnable=='0'" class="not_available">
					<p><span>即将开通</span><span>敬请期待</span></p>
				</div>
			</div>
	</div>
</template>

<script>
	export default{
		name: 'PageAlarmCell',
		props: {
			cellData: {
				type: Object,
				default(){
					return {};
				}
			},
			imageData: {
				type: String,
				dafault: ""
			}
		},
		methods:{
			addTab:function(almtype,almname,pagename,isenable){
				if (isenable=='0'){
					return;
				}
				
				const obj = {
						name:'报警计划-' + almname,
						id:'PageAlarmPlanDetail',
						route:'/indexhome/alarmPlanDetail' + almtype,
						No:'alarmdetail' + almtype,
						params:{almtype: almtype,almname:almname,pagename:pagename}
					}
				this.$router.push({path:'/indexhome/alarmPlanDetail' + almtype,query:{almtype: almtype,almname:almname,pagename:pagename}});
				this.$store.dispatch('addTab',obj);
			},
			addAlarmTab:function(almtype){
				const obj = {
					name:'报警计划一览',
					id:'PageAlarmPlanList',
					route:'/indexhome/alarmPlanList',
					No:'alarmPlanList'
				}
				this.$router.push('/indexhome/alarmPlanList');
				this.$store.dispatch('addTab',obj);
				this.$store.dispatch('setalmplantype',almtype);
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// PageAlarmCell.vue?f36f4e08